module.exports = __webpack_public_path__ + "static/media/cc.547ff326.svg";